export default __webpack_public_path__ + "static/InformFirstImage-1c559d99d4f064b119ba1111d69021a7.png";